import React from 'react';
import { observer } from 'mobx-react-lite';
import Logo from '../../assets/img/Logo.webp';
import { loadingStore } from '../../store/loadingStore';

const LoadingContent = observer(() => {
  return (
    <div className='wrapper'>
      <div className='loading-holder'>
        <div className='img-container'>
          <img className='inner-container-logo' src={Logo} alt='#' />
        </div>
        <div className='bottom-row'>
          <div className='loader-row'>
            <div className='loader-row-wrapper'>
              <div className='loader-border' />
              <div className='loader-bg' />
              <div className='move-row '>
                <div className='move-row-inner'>
                  <div
                    className='load-img-cont'
                    style={{ transform: `translateX(${loadingStore.progress - 100}%)` }}
                    onTransitionEnd={() => {
                      if (loadingStore.progress === 100) {
                        loadingStore.setTimerState(true);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <p className='loader-percent'>{loadingStore.progress}%</p>
        </div>
      </div>
    </div>
  );
});

export default LoadingContent;
